import { h, render, Component } from 'preact';
import { classNames, checkRequiredInvalid, checkPhoneInvalid, checkEmail } from '../utils/utils';
import TxrInput from './txr-input';
import { appConfig } from '../app.config';
import qs from 'qs';
import axios from 'axios';
import { HubspotService } from '../hubspot.service';

class TxrCheckNumberForm extends Component {
    state = {
        isSubmitted: false,
        isValid: false,
        messageSent: false,
        resultCode: undefined,
        isLoading: false,
        errors: {
            required: 'Required field',
            email: 'Please enter a valid e-mail',
            phone: 'Phone numbers must be 10 or 11 digits.'
        },
        firstNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        lastNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        emailModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkEmail(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        phoneModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkPhoneInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
    }
    sent = () => {
        this.state.isSubmitted = true;
        this.setState({isSubmitted: true});

        this.state.firstNameModel.change(this.state.firstNameModel);
        this.state.lastNameModel.change(this.state.lastNameModel);
        this.state.emailModel.change(this.state.emailModel);
        this.state.phoneModel.change(this.state.phoneModel);

        if (this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.phoneModel.invalid || this.state.emailModel.invalid) {
            return;
        }
        this.setState({isLoading: true});

           const hubspot = new HubspotService();
        
                hubspot.submitFormV3([
                    {
                        name: 'firstname',
                        value: this.state.firstNameModel.value
                    },
                    {
                        name: 'lastname',
                        value: this.state.lastNameModel.value
                    },
                    {
                        name: 'email',
                        value: this.state.emailModel.value
                    },
                    {
                        name: 'phone',
                        value: this.state.phoneModel.value
                    },   
                ], appConfig.hubspotCheckNumberFormId);


        var data =
        {
            VisitorName: `${this.state.firstNameModel.value} ${this.state.lastNameModel.value}`,
            PhoneNumber: this.state.phoneModel.value,
            Email: this.state.emailModel.value
        };

        const d = {};
        
        for (var p in data) {
            if (!data[p]) {
                continue;
            }
            d[encodeURIComponent(p)] = encodeURIComponent(data[p]);
        }
       
        const url = appConfig.url + '/webservices/TwilioNumbers/CheckHostingEligibility';
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(d),
            url,
        };
        axios(options)
        // axios.post(url, params)
        .then((response) => {
            this.setState({isLoading: false});
            this.checkResult(response.data);
        })
        .catch(() => {
                this.setState({isLoading: false});
                alert('Something gone wrong!');
        });
    }
    checkResult = (res) => {
        if (res.AlreadyInService) {
            this.setState({ resultCode: 'alreadyInService'});
            return;
        }
        if (res.PhoneNumberType === 'mobile' || !this.checkCountryCode(res.CountryCode)) {
            this.setState({ resultCode: 'impossible'});
            return;
        }
        if (res.PhoneNumberType === 'landline') {
            this.setState({ resultCode: 'success'});
        }
        if (res.PhoneNumberType === 'voip') {
            this.setState({ resultCode: 'possible'});
        }
      }
    
    checkCountryCode = (code) => {
        if (code === 'US' || code === 'CA') {
            return true;
        }
        return false;
      }
      onSubmit = e => {
        return false;
      }
    checkAnotherNumber = () => {
        this.setState({resultCode: undefined});
      }
    render() {
        return (
            <div class="txr-check-number-form">
            {!this.state.resultCode &&
                <form onsubmit={this.onSubmit} class="check-number__form">
                    <div class="txr-form__item-line">
                        <div class="txr-form__item">
                            <TxrInput model={this.state.firstNameModel} type="text" label="First Name" errors={this.state.errors}> </TxrInput>
                        </div>
                        <div class="txr-form__item">
                            <TxrInput model={this.state.lastNameModel} type="text" label="Last Name" errors={this.state.errors}> </TxrInput>
                        </div>
                    </div>
                    <div class="txr-form__item">
                        <TxrInput model={this.state.emailModel} type="email" label="Your Email" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__item">
                        <TxrInput model={this.state.phoneModel} type="text" label="Number you wish to use" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__button">
                            <button class="txr-button txr-primary-button" disabled={(this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.phoneModel.invalid || this.state.emailModel.invalid) && this.state.isSubmitted} type="button" onClick={() => this.sent()}>
                                <span class="txr-button__content"> CHECK MY NUMBER
                                    {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                    {this.state.isLoading && <i class="fas fa-circle-notch fa-spin"></i>}
                                </span>
                            </button>
                      </div>

                </form>
            }
            {this.state.resultCode=='success' &&
            <div class="check-success">
                  <div class="check-success__title">  
                    <img src="/images/success-check-circle.svg" class="txr-dialog__icon"/>
                    <span>Congratulations!</span>
                  </div>
                  <div class="check-form__hint check-centered__hint">You can use Text Request with your number.</div>
                  <div class="check-form__button-place" >
                        <a class="txr-button-link" href="/pricing"><button class="txr-button txr-primary-button">GET&nbsp;STARTED&nbsp;TODAY</button></a>
                  </div>
                </div>
            }
             {this.state.resultCode=='possible' &&
                <div class="check-possible">
                    <div class="check-form__hint">This could work! This looks like a VOIP number. Most of these will work with Text Request, but we need to look into it. We will call you shortly with more information after we investigate.</div>
                    <div class="check-form__button-place" >
                        <button onClick={() => this.checkAnotherNumber()} class="txr-button txr-action-button txr-black-text">CHECK&nbsp;ANOTHER&nbsp;NUMBER</button>
                    </div>
                    <div class="check-form__button-place" >
                        <a class="txr-button-link" href="/pricing"><button class="txr-button txr-primary-button">GET&nbsp;NUMBER&nbsp;FROM&nbsp;US</button></a>
                    </div>
                </div>
             }
              {this.state.resultCode=='alreadyInService' &&
                <div class="check-possible">
                    <div class="check-form__hint check-centered__hint">This number is already being used on Text Request.</div>
                    <div class="check-form__button-place" >
                        <button onClick={() => this.checkAnotherNumber()} class="txr-button txr-action-button txr-black-text">CHECK&nbsp;ANOTHER&nbsp;NUMBER</button>
                    </div>
                    <div class="check-form__button-place" >
                        <a class="txr-button-link" href="/pricing"><button class="txr-button txr-primary-button">GET&nbsp;NUMBER&nbsp;FROM&nbsp;US</button></a>
                    </div>
                </div>
              }
               {this.state.resultCode=='impossible' &&
                <div class="check-impossible">
                    <div class="check-impossible__title">  
                        <span>Sorry</span>
                    </div>
                    <div class="check-form__hint check-centered__hint">Mobile phone numbers cannot be used for Text Request. If you think this is an error, please <a href="/contact">contact us</a>.</div>
                    <div class="check-form__button-place" >
                        <button onClick={() => this.checkAnotherNumber()} class="txr-button txr-action-button txr-black-text">CHECK&nbsp;ANOTHER&nbsp;NUMBER</button>
                    </div>
                    <div class="check-form__button-place" >
                        <a class="txr-button-link" href="/pricing"><button class="txr-button txr-primary-button">GET&nbsp;NUMBER&nbsp;FROM&nbsp;US</button></a>
                    </div>
                </div>
               }
            </div>
        )
    }
}

export default TxrCheckNumberForm;